import React from 'react'
import CheckoutFS from '../Checkout/CheckoutFS';

export default function Basket() {

    return (
            <CheckoutFS/>
    )
}
